import React from "react";
import styled from "@emotion/styled";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { PhoneMask } from "@components/mask-components";

const sharestylebtn = `
  width: 100%;
  height: 45px;
  max-width: 300px;
  border-radius: 50px;
  border: none;
  outline: none;
  padding: 0 1.5rem;
  
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  font-family: var(--font-family);
  column-gap: 8px;
  margin: auto;
 
`;

const ButtonPhone = styled.button`
  ${sharestylebtn}
  background-color: black;
`;

interface WsButtonPhoneProps {
  phone: string | number;
  label?: string;
  style?: React.CSSProperties;
  onClick?: (phone?: string | number) => void;
}

const WsButtonPhone: React.FC<WsButtonPhoneProps> = ({
  phone,
  label = "LLAMAR",
  style,
  onClick,
}) => {
  return (
    <ButtonPhone style={style} onClick={() => onClick?.(phone)}>
      <LocalPhoneIcon sx={{ color: "white" }} />
      {label}
      <PhoneMask value={phone} displayType="text" />
    </ButtonPhone>
  );
};

export default WsButtonPhone;
